/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Location } from './Location';
import {
    LocationFromJSON,
    LocationFromJSONTyped,
    LocationToJSON,
    LocationToJSONTyped,
} from './Location';

/**
 * 
 * @export
 * @interface UpdateLocationResponse
 */
export interface UpdateLocationResponse {
    /**
     * 
     * @type {Location}
     * @memberof UpdateLocationResponse
     */
    data: Location;
}

/**
 * Check if a given object implements the UpdateLocationResponse interface.
 */
export function instanceOfUpdateLocationResponse(value: object): value is UpdateLocationResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function UpdateLocationResponseFromJSON(json: any): UpdateLocationResponse {
    return UpdateLocationResponseFromJSONTyped(json, false);
}

export function UpdateLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LocationFromJSON(json['data']),
    };
}

  export function UpdateLocationResponseToJSON(json: any): UpdateLocationResponse {
      return UpdateLocationResponseToJSONTyped(json, false);
  }

  export function UpdateLocationResponseToJSONTyped(value?: UpdateLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LocationToJSON(value['data']),
    };
}

